module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I: K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#id_1"
    }
  }, [_vm._v("Chickadee Creek Farm")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter01#id_2"
    }
  }, [_vm._v("Comeback Farm")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter01#id_3"
    }
  }, [_vm._v("Great Road Farm")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter01#id_4"
    }
  }, [_vm._v("Robson’s Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II: A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPLING OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARMERS")]), _vm._v("’ M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKETS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#id_1"
    }
  }, [_vm._v("Collingswood Farmers’ Market")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter02#id_2"
    }
  }, [_vm._v("Hunterdon Land Trust Farmers’ Market")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter02#id_3"
    }
  }, [_vm._v("Newark Farmers’ Markets")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter02#id_4"
    }
  }, [_vm._v("Ramsey Farmers’ Market")]), _vm._v(" * "), _c('a', {
    attrs: {
      "href": "#/chapter02#id_5"
    }
  }, [_vm._v("West Windsor Community Farmers’ Market")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III: S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asparagus")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beets")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bok Choy")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli Rabe")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collard Greens")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dandelions")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fava Beans")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lettuce")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parsley")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peas")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radishes")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhubarb")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter03#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV: S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basil")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blackberries")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberries")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cantaloupe")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherries")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cucumbers")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grapes")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nectarines")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Okra")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peaches")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peppers")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plums")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swiss Chard")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomatoes")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter04#id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" V: F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apples")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butternut Squash")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cauliflower")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celery")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberries")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kale")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pears")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkins")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaghetti Squash")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("String Beans")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potatoes")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomatillos")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter05#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" VI: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acorn Squash")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabbage")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrots")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endive")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leeks")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushrooms")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parsnips")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potatoes")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rutabaga")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach")]), _vm._v(" * "), _c('span', {
    attrs: {
      "href": "#/chapter06#id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Radishes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" VII: R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECIPES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: New Jersey Farmers’ Markets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0